import React from 'react';
import { renderable } from '../../PropTypes';
import './index.scss';

const Title = ({ children }) => <h1 className="header-title">{children}</h1>;

Title.propTypes = {
    children: renderable,
};

Title.defaultProps = {
    children: null,
};

export default Title;
